<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="payroll.menuItemLabels.vacationAdjustments"
        [menuService]="payrollModuleMenuService"
    ></app-header>
    <ui-banner *ngIf="pendingPayroll()" variant="warning" class="margin-y-3">
        {{ 'payroll.vacationYtdAdjuster.pendingPayroll' | translate }}
    </ui-banner>
    <ui-card>
        <app-segment-header
            class="margin-top-2"
            [title]="'payroll.vacation-ytds.vacationBalance' | translate"
        ></app-segment-header>
        <ui-banner *ngIf="showWarning()" variant="info" class="margin-y-3">
            {{ 'payroll.vacationYtdAdjuster.showWarning' | translate }}
        </ui-banner>
        <app-table
            *ngIf="displayVacationYtdAdjusterTable"
            [useStickyHeader]="false"
            [table]="vacationYtdAdjusterTable"
            [showSearch]="false"
            [useStickyHeader]="false"
            [showOffset]="false"
            [showActionsPadding]="false"
            [embedded]="true"
            (menuItemSelected)="menuAction($event)"
            class="table margin-top-3"
        >
            <app-empty-state
                [label]="
                    !vacationYtdAdjusterTable.hasFiltersApplied() ? 'payroll.vacationYtdAdjuster.nothingToDisplay' : ''
                "
                src="/assets/illustrations/piggy-bank.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
